import { Grid } from "@mui/material";
import Utility from "../../../common/utilities";
import { Chip } from "../../../Components2/Chip/Chip";
import React from "react";
import { IKeyValue, IHeaderTemplateBaseProp } from "../../../Model/UI";
import { KeyValue } from "../../../Components2/KeyValue/KeyValue";
import UserDetails from "../../UserDetails/UserDetails";

import "./Header4.scss";

export interface IHeader4Prop extends IHeaderTemplateBaseProp {
  label1: string;
  label2: string;
  label3: string;
  keyValue1: IKeyValue;
  chip1: string;
}
/*
UI placement:

    label1          label2 
    label3
    userDetails     chip1
                    keyValue1       
 */

export function Header4(props: IHeader4Prop)  {
  function getHeaderUI()  {
    return (
      <div
        data-testid="header-4"
        className={Utility.getClassNamesFromProps("header-4", props.className)}
      >
        {/* 1st row */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="row-1"
        >
          <div className="dot"></div>
          <p className="label-1">{props.label1}</p>
          <div className="spacer"></div>
          <p className="label-2">{props.label2}</p>
        </Grid>

        {/* 2nd row */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="row-2"
        >
          <p className="label-3">{props.label3}</p>
        </Grid>

        {/* 3rd row */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="row-3"
        >
          <UserDetails
            token={"test"}
            userId={props.userDetails.userId}
            userCardName={props.userDetails.userCardName}
            userOrganization={props.userDetails.userOrganization}
          ></UserDetails>
          <div className="spacer"></div>
          <div className="col-1">
            <Chip className="chip-1" label={props.chip1}></Chip>
            <KeyValue
              className="key-value-1"
              _key={props.keyValue1._key}
              value={props.keyValue1.value}
              seperator={":"}
            ></KeyValue>
          </div>
        </Grid>
      </div>
    );
  }

  return getHeaderUI();
}
